import { IItemForGetShortInfo, ITotalPrice, IItemForGetShortDishInfo } from 'types';
import React from 'react';
import SuggestedDishCategorySelect from './components/SuggestedDishCategorySelect';
import SuggestedDishSubCategorySelect from './components/SuggestedDishSubCategorySelect';
import SuggestedDishMultipleSelect from './components/SuggestedDishMultipleSelect/SuggestedDishMultipleSelect';
import DnDList from './components/DnDList';
import style from './SuggestedDishesField.module.scss';

interface ISuggestedDishesField {
	setFetchedCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedSuggestedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedSuggestedDishes: (value: IItemForGetShortInfo[]) => void;
	setSuggestedDishCategory: (value: Nullable<string>) => void;
	setSuggestedDishSubCategory: (value: Nullable<string>) => void;
	setSuggestedDishes: (value: string[]) => void;
	removeSuggestedDish: (value: string) => void;
	totalPrices: ITotalPrice[];
	selectedSuggestedDishCategory: Nullable<string>;
	selectedSuggestedDishSubCategory: Nullable<string>;
	selectedSuggestedDishes: string[];
	fetchedSuggestedDishes: IItemForGetShortDishInfo[];
}

const SuggestedDishesField: React.FC<ISuggestedDishesField> = ({
	setFetchedCategories,
	setFetchedSuggestedDishSubCategories,
	setFetchedSuggestedDishes,
	setSuggestedDishCategory,
	setSuggestedDishSubCategory,
	setSuggestedDishes,
	removeSuggestedDish,
	totalPrices,
	selectedSuggestedDishCategory,
	selectedSuggestedDishSubCategory,
	selectedSuggestedDishes,
	fetchedSuggestedDishes,
}) => {
	return (
		<div className={style.container} data-test="SuggestedDishesField">
			<div className={style.newSuggestedDishFields}>
				<SuggestedDishCategorySelect
					totalPrices={totalPrices}
					setSuggestedDishCategory={setSuggestedDishCategory}
					setFetchedCategories={setFetchedCategories}
				/>
				<SuggestedDishSubCategorySelect
					selectedSuggestedDishCategory={selectedSuggestedDishCategory}
					setFetchedSuggestedDishSubCategories={setFetchedSuggestedDishSubCategories}
					setSuggestedDishSubCategory={setSuggestedDishSubCategory}
				/>
				<SuggestedDishMultipleSelect
					selectedSuggestedDishes={selectedSuggestedDishes}
					selectedSuggestedDishSubCategory={selectedSuggestedDishSubCategory}
					setSuggestedDishes={setSuggestedDishes}
					setFetchedSuggestedDishes={setFetchedSuggestedDishes}
				/>
			</div>
			<DnDList
				selectedSuggestedDishes={selectedSuggestedDishes}
				fetchedSuggestedDishes={fetchedSuggestedDishes}
				setSuggestedDishes={setSuggestedDishes}
				removeSuggestedDish={removeSuggestedDish}
			/>
		</div>
	);
};

export default React.memo(SuggestedDishesField);
